import React, { Component } from 'react';
import { Alert } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import BetHistory from '../components/BetTable/history';
import { getBetHistory } from "../actions/betsActions";
import { formatDateDisplay, formatCurrency, windowResize } from "../utils";
import HistoryBar from '../components/HistoryBar';
import Loader from '../components/Loader';
import { getMessages } from '../actions/messageActions';
import { getEvents } from "../actions/eventsAction";
import { getDraws } from "../actions/eventsAction";
import BetBar from '../components/BetBar';
class BetsSettledHistoryPage extends Component {

  componentDidUpdate(prevProps, prevState) {
    if (prevProps !== this.props) {
      windowResize();
    }
  }

  componentDidMount() {
    this.props.getBetHistory();
    if (this.props.gamesList == '') {
      this.props.getEvents();
      this.props.getDraws();
    }
    windowResize();
  }

  render() {
    let isSuccessPage = false;//(this.props.location !== undefined);

    let tableTitle = (isSuccessPage ? "Bet Details" : "My Bets");
    const jackpots = []
    let gameslistKeys = Object.keys(this.props.gamesList);
    for (let j = 0; j < gameslistKeys.length; j++) {
      jackpots.push({
        name: gameslistKeys[j], link: gameslistKeys[j].toLowerCase()
      })
    }
    if (jackpots.length == 0) {
      jackpots.push({
        name: "Multi-Market", link: "multi-market"
      })
    }
    return (
      <div>
        {/* {this.props.gamesList!= '' && */}

        <BetBar jackpot={jackpots[0]} />
        {/* } */}
        <HistoryBar open="false" />
        {isSuccessPage &&
          <div>
            {/* <Alert className="text-center" variant="success">Bet successfully submitted. Check details below.</Alert> */}
            <Link className="btn rounded betbar-button btn-secondary" to={{ ...location, pathname: "/" }}>Back to Lobby</Link>
          </div>
        }
        {this.props.betsHistory !== '' ?
          <BetHistory result="true" tableTitle={tableTitle} expandFirst={isSuccessPage} data={this.props.betsHistory} />
          :
          <Loader />
        }
        {isSuccessPage &&
          <Link className="btn rounded betbar-button btn-secondary mb-5" to={{ ...location, pathname: "/" }}>Back to Lobby</Link>
        }
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    messages: state.messageReducer.messages,
    betsHistory: state.betsReducer.betsHistory,
    gamesList: state.eventsReducer.gamesList
  }
}

export default connect(mapStateToProps, { getBetHistory, getMessages, getDraws, getEvents })(BetsSettledHistoryPage);




// WEBPACK FOOTER //
// ./pages/betsSettledHistoryPage.js